import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Header from './components/Header';
import Articles from './components/Articles';
import Footer from './components/Footer';
import ModernJavaScriptTechniques from './pages/ModernJavaScriptTechniques';
import BuildingPerformantReactApplications from './pages/BuildingPerformantReactApplications';
import PythonForDataScience from './pages/PythonForDataScience';
import TheFutureOfAIInSoftwareDevelopment from './pages/TheFutureOfAIInSoftwareDevelopment';
import EssentialCybersecurityPracticesForWebDevelopers from './pages/EssentialCybersecurityPracticesForWebDevelopers';
import ArticlesListPage from './pages/ArticlesListPage';
import BenefitsOfUsingDockerIn2025 from './pages/BenefitsOfUsingDockerIn2025';
import AnsibleTipsAndTricks from './pages/AnsibleTipsAndTricks';
import KubernetesBasics from './pages/KubernetesBasics';
import DeepDiveIntoTerraform from './pages/DeepDiveIntoTerraform';
import HowToUsePythonInDevOps from './pages/HowToUsePythonInDevOps';
import WillAITakeOver from './pages/WillAITakeOver';
import './styles/App.css';


function HomePage() {
  return (
    <>
      <Navbar />
      <Header />
      <main>
        <Articles />
      </main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/articles" element={<ArticlesListPage />} />
          <Route path="/articles/modern-javascript-techniques" element={<ModernJavaScriptTechniques />} />
          <Route path="/articles/building-performant-react-applications" element={<BuildingPerformantReactApplications />} />
          <Route path="/articles/python-for-data-science" element={<PythonForDataScience />} />
          <Route path="/articles/future-of-ai-in-software-development" element={<TheFutureOfAIInSoftwareDevelopment />} />
          <Route path="/articles/essential-cybersecurity-practices" element={<EssentialCybersecurityPracticesForWebDevelopers />} />
          <Route path="/articles/benefits-of-using-docker-in-2025" element={<BenefitsOfUsingDockerIn2025 />} />
          <Route path="/articles/ansible-tips-and-tricks" element={<AnsibleTipsAndTricks />} />
          <Route path="/articles/kubernetes-basics" element={<KubernetesBasics />} />
          <Route path="/articles/deep-dive-into-terraform" element={<DeepDiveIntoTerraform />} />
          <Route path="/articles/how-to-use-python-in-devops" element={<HowToUsePythonInDevOps />} />
          <Route path="/articles/will-ai-take-over" element={<WillAITakeOver />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
